import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { AwardsService, AwardProgramInfo } from 'services/awards/awards.service';
import { ErrorService } from 'services/error/error.service';
import { NotificationService, NotificationItem } from 'services/notification/notification.service';
import { UserInfo, UserService } from 'services/user/user.service';
import { ApplicationService } from 'services/application/application.service';
import { SettingsService } from 'services/settings/settings.service';

@Component({
    selector: 'app-home',
    styleUrls: ['home.component.scss'],
    templateUrl: 'home.component.html'
})

export class HomeComponent implements OnInit, OnDestroy {
    private _subrelease: Subject<void> = new Subject<void>();

    AwardInfo: AwardProgramInfo;
    LastLogin: Date;
    Notifications: NotificationItem[];
    User: UserInfo;
    ViewReady: boolean;
	CurrentSchool: string;
	CurrentSchoolYear: string;

	constructor(private appSvc: ApplicationService, private awardSvc: AwardsService, private errorSvc: ErrorService,
		private notificationsSvc: NotificationService, private userSvc: UserService, private settingsSvc: SettingsService) {
    }

    ngOnDestroy() {
        this._subrelease.next(); this._subrelease.complete();
    }

    ngOnInit() {
        const self = this;
        self.LastLogin = null;
        self.Notifications = [];
        self.ViewReady = false;

        self.awardSvc.CurrentAwardsSub.pipe(
            takeUntil(self._subrelease),
            filter(aw => !!aw)
        ).subscribe(award => {
            // Get the current award program
            self.AwardInfo = award;

			self.settingsSvc.CurrentSchoolYearSubject.pipe(takeUntil(self._subrelease)).subscribe(year => {
				this.CurrentSchoolYear = year;

				self.userSvc.UserSubject.pipe(takeUntil(self._subrelease)).subscribe(user => {
					self.User = user;
					if (user == null) return;
					self.settingsSvc.CurrentSchoolSubject.pipe(takeUntil(self._subrelease)).subscribe(school => {
						if (user.CurrentRole === 'Developer' || user.CurrentRole === 'SystemAdmin') {
							self.ViewReady = true;
						}
						else if (user.CurrentRole === 'Judge') {
							//TODO: maybe add notifications for judge
							self.appSvc.GetJudgeNominees(user.AuthToken, user.CurrentRole, self.AwardInfo.AwardID, null, self.CurrentSchoolYear).pipe(takeUntil(this._subrelease)).subscribe(judge => {
								self.CurrentSchool = judge.DistrictNumber === '0' ? 'All' : judge.DistrictNumber;
							});
							self.ViewReady = true;
						}
						else {
							self.notificationsSvc.GetNotifications(
								self.userSvc.User.AuthToken,
								self.userSvc.User.CurrentRole,
								self.AwardInfo.AwardID,
								self.userSvc.User.SchoolNumber,
								year
							).pipe(takeUntil(self._subrelease)).subscribe(notesInfo => {
								if (notesInfo) {
									self.LastLogin = notesInfo.LastLogin;
									self.Notifications = notesInfo.Notices;
								}

								self.ViewReady = true;
							}, error => self.errorSvc.HandleServiceError(error));
						}

						if (school != null) {
							self.CurrentSchool = school.SchoolName + ' (' + (school.InSchoolGroup ? school.SchoolNumberList : school.SchoolNumber) + ')';
						}
					});
				});
			});
        });
    }
}
